import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Otp_url, Reotp_url } from "../../api/urls";
import { api } from "../../api/api";
import { toast } from "react-toastify";

const OTPPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [token, setToken] = useState();

  useEffect(() => {
    setToken(decodeURIComponent(searchParams.get("token")));
  }, [searchParams]);

  const [otp, setOtp] = useState(Array(6).fill(""));
  const [error, setError] = useState(null);
  const [timer, setTimer] = useState(60);
  const [resendDisabled, setResendDisabled] = useState(false);
  const inputRefs = useRef([]);

  const handleOtpChange = (e, index) => {
    const value = e.target.value;
    if (value.match(/[^0-9]/)) return;
    const otpCopy = [...otp];
    otpCopy[index] = value;
    setOtp(otpCopy);

    if (value && index < 5) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const enteredOtp = otp.join("");

    if (enteredOtp.length < 6 || otp.some((digit) => digit === "")) {
      setError("Please enter a complete 6-digit OTP.");
      return;
    }

    try {
      const response = await api.post(
        Otp_url,
        { recipient_otp: enteredOtp },
        {
          headers: {
            Token: token,
          },
        }
      );

      if (response.status === 200 || response.status === 201) {
       
      } else {
        toast.error(response.data.message || "Invalid OTP. Please try again.");
      }
    } catch (err) {
      console.error("Error Verifying OTP:", err);
      toast.error(
        err.response?.data?.message || "Failed to verify OTP. Try again."
      );
    }
  };

  useEffect(() => {
    if (timer === 0) {
      setResendDisabled(false);
      return;
    }

    const interval = setInterval(() => {
      setTimer((prevTimer) => prevTimer - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);

  const handleResend = async () => {
    try {
      await api.post(Reotp_url, {});
      setOtp(Array(6).fill(""));
      setTimer(30);
      setResendDisabled(true);
      setError(null);
    } catch (err) {
      console.error("Error Resending OTP:", err);
      setError(err.response?.data?.message || "Failed to resend OTP.");
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          backgroundColor: "#FAF9F8",
          borderRadius: "8px",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          border: "1px solid rgba(0, 0, 0, 0.2)",
          padding: "40px",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "24px",
            marginBottom: "20px",
            color: "#333",
          }}
        >
          Enter OTP
        </h2>

        <form
          onSubmit={handleSubmit}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", marginBottom: "20px" }}>
            {otp.map((digit, index) => (
              <input
                key={index}
                type="text"
                value={digit}
                onChange={(e) => handleOtpChange(e, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                maxLength="1"
                ref={(el) => (inputRefs.current[index] = el)}
                style={{
                  width: "40px",
                  height: "40px",
                  textAlign: "center",
                  fontSize: "20px",
                  marginRight: "10px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  marginBottom: "10px",
                }}
              />
            ))}
          </div>

          {error && (
            <p style={{ color: "red", marginBottom: "10px" }}>{error}</p>
          )}

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px",
              background: "#000000",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: "pointer",
              fontSize: "16px",
              transition: "background-color 0.3s ease",
            }}
          >
            Verify OTP
          </button>
        </form>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <button
            onClick={handleResend}
            disabled={resendDisabled}
            style={{
              width: "100%",
              padding: "10px 20px",
              background: "#FFFFFF",
              border: "1px solid #00000066",
              color: "black",
              borderRadius: "4px",
              cursor: resendDisabled ? "not-allowed" : "pointer",
              fontSize: "16px",
              marginTop: "10px",
            }}
          >
            {resendDisabled ? `Resend in ${timer}s` : "Resend OTP"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OTPPage;
